/**
 * Navy footer ("LAB3D Erhverv"): 4 linkkolonner (Sortiment, Erhverv, Service,
 * LAB3D) + bundstrip med firmaoplysninger. Ren visuel komponent — interne
 * links bruger eksisterende ruter.
 */
import { Link } from "react-router-dom";

const COLUMNS: {
  heading: string;
  links: { label: string; to?: string; href?: string }[];
}[] = [
  {
    heading: "Sortiment",
    links: [
      { label: "Alle varer", to: "/produkter" },
      { label: "Favoritter", to: "/favoritter" },
      { label: "Hurtig bestilling", to: "/hurtig" },
      { label: "Cashback", to: "/cashback" },
    ],
  },
  {
    heading: "Erhverv",
    links: [
      { label: "Bliv B2B-kunde", to: "/signup" },
      { label: "Firmaindstillinger", to: "/firma" },
      { label: "Ordrehistorik", to: "/ordrer" },
      { label: "Handelsbetingelser", href: "https://lab3d.dk/policies/terms-of-service" },
    ],
  },
  {
    heading: "Service",
    links: [
      { label: "shop@lab3d.dk", href: "mailto:shop@lab3d.dk" },
      { label: "+45 21 99 03 07", href: "tel:+4521990307" },
      { label: "Levering & fragt", to: "/ordrer" },
      { label: "Min konto", to: "/konto" },
    ],
  },
  {
    heading: "LAB3D",
    links: [
      { label: "Om os", href: "https://lab3d.dk" },
      { label: "lab3d.dk", href: "https://lab3d.dk" },
      { label: "Kontakt", href: "mailto:shop@lab3d.dk" },
    ],
  },
];

export function Footer() {
  return (
    <footer className="hidden bg-navy text-navy-100 md:block">
      <div className="mx-auto grid max-w-[1400px] grid-cols-2 gap-8 px-4 py-10 lg:grid-cols-4">
        {COLUMNS.map((col) => (
          <div key={col.heading}>
            <p className="mb-3 text-sm font-bold text-white">{col.heading}</p>
            <ul className="space-y-2">
              {col.links.map((link) => (
                <li key={link.label}>
                  {link.to ? (
                    <Link to={link.to} className="text-sm text-navy-100 hover:text-white">
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      target={link.href?.startsWith("http") ? "_blank" : undefined}
                      rel={link.href?.startsWith("http") ? "noreferrer" : undefined}
                      className="text-sm text-navy-100 hover:text-white"
                    >
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-[1400px] flex-wrap items-center justify-between gap-2 px-4 py-4 text-xs text-navy-200">
          <span className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <img src="/lab3d-logo-nav.png" alt="LAB3D" className="h-5 w-auto" />
            <span>LAB3D ApS</span>
            <span>CVR 41 82 09 33</span>
            <span>Industrivej 24, 8000 Aarhus C</span>
          </span>
          <span>Alle priser er ekskl. moms</span>
        </div>
      </div>
    </footer>
  );
}
